import lazyLoading from "../lazyLoading";
import loader from "../loader";
import config from "../../../app.config";
import listRoutes from "./routerList"; //管理员
export default [
  {
    path: "/taggingManage",
    redirect: "/taggingManage/home",
    component: lazyLoading("layout/index"),
    meta: {
      title: "",
      icon: "robot",
      keepAlive: true,
    },
    children: listRoutes
  },


  //错误页面
  {
    path: "/600",
    name: "600",
    component: loader("views/exception/600.vue"),
    meta: {
      title: "链接已断开",
    },
  },
  {
    path: "/404",
    name: "404",
    component: loader("views/exception/404.vue"),
    meta: {
      title: "404",
    },
  },
  {
    path: "/500",
    name: "500",
    component: loader("views/exception/500.vue"),
    meta: {
      title: "500",
    },
  },
    {
      path: "/",
      redirect: "/login",
      component: lazyLoading("views/login/index"),
      meta: {
        title: "登录" + config.appTitle,
      },
    },
    {
      path: "/login",
      component: lazyLoading("views/login/index"),
      meta: {
        title: "登录" + config.appTitle,
      },
    },
];
